import { render, staticRenderFns } from "./ArticleContents.vue?vue&type=template&id=68c9d6b3&scoped=true&"
import script from "./ArticleContents.vue?vue&type=script&lang=js&"
export * from "./ArticleContents.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContents.vue?vue&type=style&index=0&id=68c9d6b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c9d6b3",
  null
  
)

export default component.exports